import { useCallback } from 'react';
import { IToggleControls } from '~/hooks/useToggle';
import { isValidShifts } from '../Utils';
import { ErrorType } from './Types';

interface IUseTimeOrderValidationProps {
  controls: IToggleControls;
}

export const useTimeOrderValidation = ({ controls }: IUseTimeOrderValidationProps) => {
  const doValidate = useCallback(
    (newArrival: string, newDeparture: string): ErrorType | undefined => {
      if (!isValidShifts(newArrival, newDeparture)) {
        controls.setOn();
        return ErrorType.IncorrectTimeOrder;
      }

      return undefined;
    },
    [controls],
  );

  return {
    doValidate,
  };
};
